import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap, TimelineLite} from "gsap";
import {TheBorder} from "../TheBorder";
import {TheBorderStatics} from "../TheBorderStatics";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TheBorderGameMode} from "../server/TheBorderGameMode";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderNormalBetPresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController) {
        //Fades out win numbers from previous win if any
        //TheBorder.totalWinView.abort();

        //Resets wild multiplier if avalanche is over
        this.setWinMultiplier();

        TheBorder.model.nearWinReels = [false, false, false, false, false, false];

        const tl: TimelineLite = new TimelineLite({onComplete: () => flowStateController.finish()});
        const mainReelDelay = TheBorder.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TheBorderStatics.mainReelAllOutStopDelayFastSpin : TheBorderStatics.mainReelAllOutStopDelay;

        tl.add(TheBorder.allReelsView.mainReelModels[0].start(), 0);
        tl.add(TheBorder.allReelsView.mainReelModels[1].start(), mainReelDelay);
        tl.add(TheBorder.allReelsView.mainReelModels[2].start(), mainReelDelay * 2);
        tl.add(TheBorder.allReelsView.mainReelModels[3].start(), mainReelDelay * 3);
        tl.add(TheBorder.allReelsView.mainReelModels[4].start(), mainReelDelay * 4);
        tl.add(TheBorder.allReelsView.mainReelModels[5].start(), mainReelDelay * 5);

        if (tl.duration() == 0) {
            tl.add(gsap.to(this, {duration: 0.001}));
        }
    }

    protected setWinMultiplier(): void {
        if (TheBorder.model.data.nextMode === TheBorderGameMode.NORMAL) {
            TheBorder.winMultiplierView.setWinMultiplier(1);
        }

        TheBorder.xRipButton.stopHighlightSparks();
    }
}